<template>
    <!-- show more tab modal pop-up -->
    <div class="more-tab-show-m-view">

<div class="modal fade" id="more-item-tabs" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="show-more-tabs-modal-body">
            <ul>

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-1.webp" alt="">
                        </div>
                        <div>
                            <span> Formula 1</span>
                        </div>
                    </a>
                </li> -->

                <li>
                    <a @click="gotoSportsBook('sr:sport:2')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game2.webp" alt="">
                        </div>
                        <div>
                            <span>Basketball</span>
                        </div>
                    </a>
                </li>

                <li>
                    <a @click="gotoSportsBook('sr:sport:31')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-3.webp" alt="">
                        </div>
                        <div>
                            <span>Badminton</span>
                        </div>
                    </a>
                </li>
                
                <!-- <li>
                    <a @click="gotoSportsBook('sr:sport:2')">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-4.webp" alt="">
                        </div>
                        <div>
                            <span>Golf</span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/horse.webp" alt="">
                        </div>
                        <div>
                            <span>Horse Racing</span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/greyhound.webp" alt="">
                        </div>
                        <div>
                            <span>Greyhound Racing</span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/global-network.webp" alt="">
                        </div>
                        <div>
                            <span>Virtual Sports</span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-5.webp" alt="">
                        </div>
                        <div>
                            <span>Counter Strike</span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/gold-pot.webp" alt="">
                        </div>
                        <div>
                            <span>Matka</span>
                        </div>
                    </a>
                </li> -->

                <li>
                    <a @click="gotoSportsBook('sr:sport:3')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-6.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Baseball
                            </span>
                        </div>
                    </a>
                </li>

                <li>
                    <a @click="gotoSportsBook('sr:sport:12')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-7.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Rugby
                            </span>
                        </div>
                    </a>
                </li>

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-8.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Boxing
                            </span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-10.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Fifa
                            </span>
                        </div>
                    </a>
                </li> -->

                <li>
                    <a @click="gotoSportsBook('sr:sport:23')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-11.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Volleyball
                            </span>
                        </div>
                    </a>
                </li>

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-12.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Fifa22-volta-
                            </span>
                        </div>
                    </a>
                </li> -->


                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-13.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Dota 2
                            </span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-14.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Ecricket
                            </span>
                        </div>
                    </a>
                </li> -->

                <li>
                    <a @click="gotoSportsBook('sr:sport:4')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-15.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Ice-hockey
                            </span>
                        </div>
                    </a>
                </li>

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-16.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Handball
                            </span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-17.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Cycling
                            </span>
                        </div>
                    </a>
                </li> -->

                <li>
                    <a @click="gotoSportsBook('sr:sport:22')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-18.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Darts
                            </span>
                        </div>
                    </a>
                </li>
                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-19.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Efighting
                            </span>
                        </div>
                    </a>
                </li> -->
                <li>
                    <a @click="gotoSportsBook('sr:sport:16')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-20.webp" alt="">
                        </div>
                        <div>
                            <span>
                                American-football
                            </span>
                        </div>
                    </a>
                </li>

                <li>
                    <a @click="gotoSportsBook('sr:sport:19')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-21.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Snooker
                            </span>
                        </div>
                    </a>
                </li>

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-22.webp" alt="">
                        </div>
                        <div>
                            <span>
                                NBA2k19
                            </span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-23.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Waterpolo
                            </span>
                        </div>
                    </a>
                </li> -->

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-24.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Bowls
                            </span>
                        </div>
                    </a>
                </li> -->

                <li>
                    <a @click="gotoSportsBook('sr:sport:20')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-25.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Table-tennis
                            </span>
                        </div>
                    </a>
                </li>

                <!-- <li>
                    <a href="#">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-26.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Motorcycle-racing
                            </span>
                        </div>
                    </a>
                </li> -->

                <li>
                    <a @click="gotoSportsBook('sr:sport:21')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-27.webp" alt="">
                        </div>
                        <div>
                            <span>
                                Cricket
                            </span>
                        </div>
                    </a>
                </li>

                <li>
                    <a @click="gotoSportsBook('sr:sport:1')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-28.webp" alt="">
                        </div>
                        <div>
                            <span>
                              Soccer
                            </span>
                        </div>
                    </a>
                </li>

                <li>
                    <a @click="gotoSportsBook('sr:sport:5')" data-bs-dismiss="modal">
                        <div>
                            <img loading="lazy" src="@/assets/images/game-30.webp" alt="">
                        </div>
                        <div>
                            <span>
                             Tennis
                            </span>
                        </div>
                    </a>
                </li>
                

            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: "MobileSportSelection",
    data(){
        return{
            sportsBookGames:[
            {
                "id": 'sr:sport:21',
                "name": 'Criket',
            },
            ]
        }
    },
    methods: {
        gotoSportsBook(id){
            this.$router.push({ name: 'sports-book-wise', params: { id: id } })
        },
        showErrorModalFunc(message) {
            this.$emit('error-modal', message);
        },
        showSuccessModalFunc(message) {
            this.$emit('success-modal', message);
        }
    }
}
</script>